import React from "react";
import { Button } from "@speedoc/design-assets";
import { scrollToNextSection } from "../../utils/scrollToNextSection";
import { trackCustom } from "../../services/analytics";
import { GlobalStore } from "../../stores/global";

const ButtonLink = ({ linkText, linkUrl, linkClass = "primary", tracking = null }) => {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);

  const Container = ({ children }) => (linkUrl?.includes("#") ? <>{children}</> : <a href={linkUrl}>{children}</a>);

  return (
    <Container>
      <Button
        type="button"
        className={`${linkClass} sm`}
        onClick={() => {
          scrollToNextSection(linkUrl);
          tracking && trackCustom(tracking, countryCode);
        }}>
        <span>{linkText}</span>
      </Button>
    </Container>
  );
};

export default ButtonLink;
